export default __webpack_public_path__ + "static/MS-Sans-Serif-30dfad5d3b1a7f2988234427145dc924.eot";